import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getPdfContractListContainer = store =>
  import(/* webpackChunkName: "PdfAgreement" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "PdfAgreement" */ './containers/PdfAgreementListContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [ROUTES.PDF_AGREEMENT_LIST_PATH],
    component: AsyncComponent(() => getPdfContractListContainer(store))
  }
])
